import { Image } from 'src/ui/components';
import styles from './ContentContainer.module.scss';

// @Guide

// to ensure we have content overlay that has pot image and content itself being position properly at all screens we do the following

// 1- we decrease content box padding gradually based on screen size
// 2- we push content overlay down gradually based on screen size
// 3- we add in top padding for content box itself gradually based on screensize
// 4- decrease font sizes gradually
// 5- decrease pot image size while following same width to height ratio which is width =1.12x height


// TODO: instead of pot balance, displayed totalDepositedEth

const KeymastersPotContentContainer = ( props ) => {
	// PotWithText

	const { potBalance, paused } = props;


	return <section className={`relative flex flex-col items-center w-[1000px] h-auto p-20  bg-[#0b0f1b] backdrop-blur-2xl mt-[140px] rounded-2xl max-[1000px]:w-[95%] max-[700px]:p-16 max-[500px]:p-12 max-[400px]:p-6 ${styles['keymasters-pot-content-container']} ${props.className}`}>

		<div className={`h-auto absolute flex flex-col items-center ${styles['keymasters-pot-content-container-overlay']}`}>
			<Image
				src="/images/keymasters-pot/Pot.png"
				width={375}
				height={334}
				alt="Apepe Odyssey Logo"
				className={`z-[2] relative ${styles['keymasters-pot-content-container-image-pot']}`}
			/>
			<Image
				src="/images/keymasters-pot/Star.png"
				width={618}
				height={531}
				alt="Apepe Odyssey Logo"
				className={`absolute z-[1] ${styles['keymasters-pot-content-container-image-star']}`}
			/>
			<h1 className={`w-auto relative text-[86px] uppercase bold leading-1 z-[3] -f-family-burbank  ${styles['keymasters-pot-content-container-overlay-text']} `}>keymasters’ pot</h1>
		</div>

		<div className='flex flex-col w-full h-auto max-[700px]:pt-10 max-[400px]:pt-24'>
			<div className='h-auto'>
				<h1 className="-f-family-chauncy font-bold text-center uppercase text-3xl max-[700px]:text-2xl">
					KEYMASTERS EARN
					<span className='text-[#FBFF09]'> 30% </span>
					OF ALL ODYSSEY MINTS and royalties!*
				</h1>
				<p className="text-[#D9D9D9] max-w-full overflow-hidden font-normal leading-[140%] text-center max-[700px]:text-base text-lg ">*A mechanism reward for Keymasters - those who own the Odyssey Key. 30% of all mint proceeds from the Apepe Odyssey Chapter 1, beginning from Piece #2, and all future royalties earned, go to the Keymasters’ Pot </p>
				<div className='border border-white rounded border-solid border-opacity-20'>
					{ potBalance && <p className="text-[#D9D9D9] max-w-full overflow-hidden font-normal leading-[140%] text-center max-[700px]:text-base">
					current pot balance: &nbsp;
						{ Number( potBalance ).toFixed( 2 ) }
					&nbsp;ETH 
						{' '}
						<small>(all keymasters)</small>
					</p> }
					<p
						className='text-[#D9D9D9] text-center'
						hidden={!paused}>
						Claims are currently not enabled.
					</p>
					<p
						className='text-[#D9D9D9] text-center'
						hidden={paused}>
						Reward claims are now active for Odyssey Key holders
					</p>
				</div>
			</div>
			{/* divider */}
			<div className="w-[874px] h-[1px] bg-[#fff] my-12 opacity-10" />
			{/* divider */}
			<div>{props.children}</div>
		</div>

	</section>;

};

export default KeymastersPotContentContainer;
